import _ from "lodash";
import { _getItemFromLocalDecrypted } from "network-helper";

export const getJHHID = () => {
  const currentProfile = JSON.parse(_getItemFromLocalDecrypted("_cp"));
  return _.get(currentProfile, "jio_id", null);
};
